import React from "react";
import styles from "./styles.module.css"
import clsx from "clsx";

const Separator: React.FC = () => {
  return(
    <>
      <div className={clsx(styles.separator)}></div>
    </>
  )
}
export default Separator;